import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../../context/commandsContext';
import useKeyPress from '../../../../hooks/useKeyPress';
import FullBodyContentView from '../../../views/fullBodyContentView';

function DefaultDens({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="Default Dens Factor"
      fullCaption={
        <>
          <div style={{paddingTop: "17px"}}>None <span style={{paddingLeft: "90px"}}>0.0</span></div>
          <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
          <div style={{paddingTop: "25px"}}></div>
          <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
          <div style={{paddingTop: "25px"}}></div>
          <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
          <div style={{paddingTop: "25px"}}></div>
          <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
          <div style={{paddingTop: "25px"}}></div>
          <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
        </>
      }
    />
  );
}

export default DefaultDens;
